import { SERVE_FIRST_LOGO_URL } from "../../constants/branding";

/** UI defaults not provided by the learning-development API. */
export const learningDefaults = {
  logoSrc: SERVE_FIRST_LOGO_URL,
  maxAttempts: 3,
};
